import { PartyPopper, X } from "lucide-react";
import { useState } from "react";
import { useUserProfile } from "@/contexts/UserProfileContext";
import { api } from "@/services/api";

/** `taster`: the Participant is joining a freemium taster, which has no
 * certificate, so the copy mustn't promise one (KC-504). */
export function WelcomeBanner({ taster = false }: { taster?: boolean }) {
  const { userProfile, refetch } = useUserProfile();
  const [dismissing, setDismissing] = useState(false);

  if (!userProfile || userProfile.welcomed_at) return null;

  const handleDismiss = async () => {
    setDismissing(true);
    try {
      await api.dismissWelcome();
      await refetch();
    } catch (err) {
      console.error("Failed to dismiss welcome banner:", err);
      setDismissing(false);
    }
  };

  return (
    <div className="mb-6 bg-teal-50 border border-teal-200 rounded-2xl p-4 shadow-[5px_5px_10px_rgba(0,2,6,0.05)]">
      <div className="flex items-start gap-3">
        <PartyPopper className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="text-teal-900 font-semibold mb-1">
            Welcome to the Dominion Programme, {userProfile.username}!
          </h3>
          <p className="text-teal-800/80 text-sm">
            {taster
              ? "Your account is ready. Join the free taster below to start your first Work Packages."
              : "Your account is ready. Choose a programme below to start your certification journey."}
          </p>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          disabled={dismissing}
          className="text-teal-600 hover:text-teal-900 transition-colors disabled:opacity-50"
          aria-label="Dismiss welcome message"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
